/**
 * Whether a resolved request URL targets the Ryde API (session cookies + CSRF apply only there).
 * Kept in a small module so unit tests do not load the full axios defaults / constants graph.
 */
export const isRydeApiRequestUri = ({
  requestUri,
  rydeApiBase,
}: {
  requestUri: string;
  rydeApiBase: string | undefined;
}): boolean => {
  if (rydeApiBase !== undefined && rydeApiBase !== "") {
    return (
      requestUri === rydeApiBase ||
      requestUri.startsWith(`${rydeApiBase}/`) ||
      requestUri.startsWith(`${rydeApiBase}?`)
    );
  }
  if (typeof window === "undefined") {
    return false;
  }
  try {
    const resolved = new URL(requestUri, window.location.origin);
    return resolved.origin === window.location.origin;
  } catch {
    return false;
  }
};
